import { QueryResult } from "../../../Common/domain/src/api/queryResult";
import {
  TOKEN_FLOW,
  GetTokenFlowState,
  TOKEN_FLOW_FAIL,
} from "../../domain/tokenFlow/index";

export const initialState: GetTokenFlowState = {
  loggedUser: new QueryResult({ isValid: false }) 
};

export default function startTokenFlow(state = initialState, action: any) {
  switch (action.type) {
    case TOKEN_FLOW:
      return {
        ...state,
        loggedUser: action.payload,
      };
      case TOKEN_FLOW_FAIL:
        return {
          ...state,
          loggedUser: action.payload,
        };
    default:
      return state;
  }
};
